const generateUniqueTemplateKey = (pathname: string) => {
  const pathParams = pathname.split('/');
  pathParams.shift();
  let defaultSubType = 'index';
  const subType = pathParams?.[2] && defaultSubType === 'index' ? pathParams[2] : defaultSubType;
  // Set template for `/` to 'start_index'
  const type = pathParams?.[0] || 'landing';
  return {
    template: `${type}_${subType}`,
    subType,
  };
};

export {generateUniqueTemplateKey};
